import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export interface AddTeamMemberData {
  first_name: string;
  last_name: string;
  email: string;
  role: string;
}

export default async function addTeamMember(
  teamId: string,
  memberData: AddTeamMemberData,
): Promise<void> {
  const res = await fetchOrchidAPI(`/api/users/v1/team/${teamId}/add`, {
    method: "POST",
    body: JSON.stringify(memberData),
  });

  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
}
